import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
import { business } from '../data/site';
import { usePageMeta } from '../hooks/usePageMeta';
export function NotFound() {
  usePageMeta('Page not found | East End Automotive Repair', 'The page you were looking for is not available. Call East End Automotive Repair in Oak Ridge, TN.');
  return <section className="w-full bg-ink py-20 text-white lg:py-28" data-id="element-594" data-mp="1a4anszzzbsne">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-595" data-mp="1a1y5glqb7g9t">
        <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-light" data-id="element-596" data-mp="1f23s1nhq2cl1">
          Page not found
        </p>
        <h1 className="mt-4 max-w-[620px] font-display text-[32px] font-extrabold leading-[1.06] tracking-[-0.02em] sm:text-[42px]" data-id="element-597" data-mp="1jundf6mnic0e">
          We could not find that page
        </h1>
        <p className="mt-5 max-w-[560px] text-[17px] leading-relaxed text-chalk/75" data-id="element-598" data-mp="1sw3egnrkt1ry">
          The page may have moved. Browse our services, or call the shop and we
          will point you in the right direction.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-599" data-mp="1ntr8tl2v4sjg">
          <a href={business.phoneHref} className="inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-md bg-brand px-7 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-600" data-mp="1iv7o1o009mso">
            <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-601" data-mp="26l1y5xsxwx98" />
            Call {business.phone}
          </a>
          <Link to="/services" className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-white/25 px-7 py-4 text-base font-semibold text-white transition-colors duration-150 ease-out hover:border-white/60" data-id="element-602" data-mp="22ljmlsn0dyj2">
            View All Services
          </Link>
        </div>
      </div>
    </section>;
}